import type { InjectionKey } from 'vue'
import type { FormContext, PrivateFormContext } from 'vee-validate'
import type { ProjectSettings } from '@/components/projects/interfaces.ts'

// @ts-expect-error Jevgeni fix it
type ProjectSettingsFormType = ReturnType<PrivateFormContext<ProjectSettings>>

export const ProjectSettingFormKey: InjectionKey<ProjectSettingsFormType> = Symbol('ProjectSettingForm')
export const ProjectSettingSyncInitialStateKey: InjectionKey<() => void> = Symbol('ProjectSettingSyncInitialStateKey')
